module.exports = __webpack_public_path__ + "static/media/403NoPermission.942030bc.png";